<div class="ald-wrapper"
    [ngClass]="[
        density ? 'ald-wrapper--' + density : ''
    ]">
    <ng-content></ng-content>
</div>
